import { useState } from 'react';
import { toast } from 'react-toastify';

import fleetApi from '../../services/api.service';

/**
 * Archivage d'un destinataire (POST /addresses/:id/archive)
 */
export default function useArchiveAddress() {
  const [isLoading, setIsLoading] = useState(false);

  const archiveAddress = async (addressId) => {
    try {
      setIsLoading(true);
      const response = await fleetApi.post(`/addresses/${addressId}/archive`);
      toast.success('Destinataire archivé.');
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Une erreur est survenue.'
      );
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, archiveAddress };
}
